import { ContentContainer } from 'components/containers';
import { FormattedUnitValue } from 'components/text';
import { useBoolean } from 'hooks';
import { Icon, IconName } from 'libs/icons';
import { useTranslation } from 'libs/translations';
import { IUserProfile } from 'types';

import { WidgetCheckAssuranceDetails } from '../../check-assurance/WidgetCheckAssuranceDetails';

export function CheckAssuranceColumn(props: {
  readonly userProfile: IUserProfile;
}) {
  const { t } = useTranslation();

  const [isOpen, { setFalse: close, setTrue: open }] = useBoolean(false);

  const checkAssuranceProgress =
    props.userProfile.businessData?.checkAssuranceProgress;

  return (
    <>
      <button
        className="inline-block"
        title={t('Check Assurance')}
        onClick={event => {
          event.preventDefault();
          event.stopPropagation();
          open();
        }}
      >
        {props.userProfile.businessData?.hasCheckAssurance ? (
          <span className="pt-2 block">
            <Icon name={IconName.Shield} size={16} className="text-success" />
          </span>
        ) : checkAssuranceProgress?.percent ? (
          <span className="text-sm text-primary">
            <FormattedUnitValue
              value={checkAssuranceProgress?.percent}
              unit="percent"
            />
          </span>
        ) : null}
      </button>
      {checkAssuranceProgress && (
        <ContentContainer
          title={t('Check Assurance')}
          icon={
            <Icon name={IconName.Shield} size={16} className="text-success" />
          }
          onDismiss={close}
          open={isOpen}
        >
          {checkAssuranceProgress?.options.length > 0 &&
            checkAssuranceProgress.options[0].details.length > 0 && (
              <WidgetCheckAssuranceDetails
                options={checkAssuranceProgress.options}
                percent={checkAssuranceProgress.percent}
              />
            )}
        </ContentContainer>
      )}
    </>
  );
}
